import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius8,
  borderRadius16,
  boxShadowBlack12,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import {
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { grey1, grey10, grey9 } from 'approot/shared/styles/colours.style';
import { font14, font16 } from 'approot/shared/styles/typography.style';

export const MoreInfoTooltip = styled.div`
  ${boxShadowBlack12}
  ${font16}
  
  background-color: ${grey10};
  border-radius: ${rem(borderRadius16)};
  color: ${grey1};
  overflow: hidden;
  width: ${rem(380)};
  z-index: 100;

  figure {
    margin: 0;
  }

  figcaption {
    padding: ${rem(spacing24)};
  }
`;

export const MoreInfoButton = styled.button`
  background: transparent;
  border: none;
  border-radius: ${rem(borderRadius16)};
  padding: 0;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-left: ${rem(spacing8)};

  ${standardFocusState}
  &:hover {
    cursor: pointer;
  }
`;

export const MoreInfoTooltipContent = styled.div`
  ${font14}

  background-color: ${grey9};
  box-shadow:
    0px 4px 8px -4px rgba(22, 34, 51, 0.08),
    0px 16px 24px rgba(22, 34, 51, 0.08);
  border-radius: ${rem(borderRadius8)};
  color: ${grey1};
  max-width: ${rem(320)};
  padding: ${rem(spacing8)} ${rem(spacing16)};
  z-index: 1000;
`;
